import React from 'react'
import { useSelector } from 'react-redux'

import { FormattedMessage } from 'react-intl'
import { Text, Form, FormField } from '../../../..'
import TextInput from '../../../../shared/Input/TextInput'
import { selectHomeSqFt } from '../../../../../store/selectors/home/answers'
import NavigationButtons from '../Buttons/NavigationButtons'

import styles from './HomeFactsSteps.module.scss'

const SQFT = 'sqFt'
const SqFtText = React.forwardRef((props, ref) => (
  <TextInput className={styles.homeFactsSqFtText} {...props} ref={ref} />
))

const EnterSqFt = ({ onBack, onSqFt, defaultSqFt }) => {
  const homeSqFt = useSelector(selectHomeSqFt)

  const handleSubmit = (e, data) => {
    e.preventDefault()
    const updatedSqft = data[SQFT]
    const isDirty = parseInt(homeSqFt) !== updatedSqft

    onSqFt(updatedSqft, isDirty)
  }

  return (
    <Form
      name='homeFactsSqFt'
      className={styles.homeFactsStep}
      onSubmit={handleSubmit}
      fields={[{ name: SQFT, parse: v => parseFloat(v.replace(/,/g, '')) }]}
    >
      <Text className={styles.homeFactsHeader} size='xl' variant='neutralCool' variantCount='900'>
        <FormattedMessage id='TYV.panels.sqFt.head' defaultMessage='How big is your home?' />
      </Text>
      <FormField.SqFt
        className={styles.homeFactsSqFtInput}
        customInput={SqFtText}
        name={SQFT}
        defaultValue={homeSqFt || defaultSqFt}
        allowNegative={false}
      />
      <NavigationButtons handleBack={() => onBack(50)} />
    </Form>
  )
}

export default EnterSqFt
